<template>
  <UsageExample v-model="tab" :code="code" :tabs="tabs">
    <v-container class="d-flex flex-column ga-3">
      <v-layout>
        <CsNavbar
          :title="showTitle ? 'Home' : undefined"
          :header-icon="showHeaderIcon ? 'mdi-home-outline' : undefined"
          :primary-action-label="showPrimaryActionLabel ? 'Create Excursion' : undefined"
          :footer-left-label="showFooterLeftLabel ? 'View User Information' : undefined"
          :menu-items="menuItems"
          @header-click="handleHeaderClick"
          @primary-action-click="handlePrimaryActionClick"
          @menu-item-click="handleMenuItemClick"
          @footer-left-click="handleFooterLeftClick"
          @footer-right-click="handleFooterRightClick"
        />
        <v-main style="height: 600px">
          <v-container class="pa-0">
            <v-sheet
              color="#f4f5f6"
              height="600"
              rounded="lg"
              border="dashed md"
              class="pa-4 mx-2"
            />
          </v-container>
        </v-main>
      </v-layout>
    </v-container>
    <template #configuration>
      <div class="d-flex flex-column mt-16">
        <hx-checkbox v-model="showTitle" :label="`Title: ${showTitle}`"></hx-checkbox>
        <hx-checkbox
          v-model="showHeaderIcon"
          :label="`Header icon: ${showHeaderIcon}`"
        ></hx-checkbox>
        <hx-checkbox
          v-model="showPrimaryActionLabel"
          :label="`Primary action label: ${showPrimaryActionLabel}`"
        ></hx-checkbox>
        <hx-checkbox
          v-model="showFooterLeftLabel"
          :label="`Footer left label: ${showFooterLeftLabel}`"
        ></hx-checkbox>
      </div>
    </template>
  </UsageExample>
</template>

<script>
import UsageExample from '@/components/helix/utils/UsageExample';

export default {
  name: 'CSNavBar',
  components: {
    UsageExample
  },

  setup() {
    const code = `
 <CsNavbar
          title="Home"
          headerIcon="mdi-home-outline"
          primaryActionLabel="Create Excursion"
          footerLeftLabel="View User Information"
          :menu-items="[
                {
                id: 'excursion-management',
                title: 'Excursion Management',
                icon: '$i-global-file',
                children: [{ title: 'Excursions' }, { title: 'Excursion Templates' }]
                }
            ]"
          @header-click="handleHeaderClick"
          @primary-action-click="handlePrimaryActionClick"
          @menu-item-click="handleMenuItemClick"
          @footer-left-click="handleFooterLeftClick"
          @footer-right-click="handleFooterRightClick"
        />
    `;

    return {
      code
    };
  },

  data() {
    return {
      tab: 'Nav Bar Usage',
      tabs: ['Nav Bar Usage'],
      menuItems: [
        {
          id: 'excursion-management',
          title: 'Excursion Management',
          icon: '$i-global-file',
          children: [{ title: 'Excursions' }, { title: 'Excursion Templates' }]
        },
        {
          id: 'client-management',
          title: 'Client Management',
          icon: '$i-quality-control-professional',
          children: [
            { title: 'Site Users' },
            { title: 'Groups' },
            {
              title: 'Risk Matrix Management'
            },
            { title: 'Risk Category Management' },
            {
              title: 'Operation Management'
            }
          ]
        }
      ],
      showTitle: true,
      showHeaderIcon: true,
      showPrimaryActionLabel: true,
      showFooterLeftLabel: true
    };
  },
  methods: {
    handleHeaderClick() {
      console.log('Header clicked');
    },
    handlePrimaryActionClick() {
      console.log('Primary action clicked');
    },
    handleFooterLeftClick() {
      console.log('Footer left clicked');
    },
    handleFooterRightClick() {
      console.log('Footer right clicked');
    },
    handleMenuItemClick(item, index) {
      console.log('Menu item clicked:', item, index);
    }
  }
};
</script>
